import { isMobileUserAgent } from './platform';
import { REPORT_ERROR } from '../actions/Reporting';
const FALLBACK_LOCALE = 'en-US';
const FALLBACK_TIMEZONE = 'America/Los_Angeles';
export const getICalURL = (icalFormattedStartDate, icalFormattedEndDate, summary, description) => {
    const urlWithRef = new URL(document.URL);
    urlWithRef.searchParams.append('ref', 'dm_aml_cal');
    let calendarUrl = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `URL:${urlWithRef}`,
        `DTSTART:${icalFormattedStartDate}`,
        `DTEND:${icalFormattedEndDate}`,
        `SUMMARY:${summary}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${urlWithRef}`,
        'END:VEVENT',
        'END:VCALENDAR',
    ].join('\n');
    if (isMobileUserAgent()) {
        calendarUrl = encodeURI(`data:text/calendar;charset=utf8,${calendarUrl}`);
    }
    return calendarUrl;
};
export const getLocalizedEventTime = (date, formattedLocaleString, timeZone, dispatch) => {
    try {
        return date.toLocaleTimeString(formattedLocaleString, {
            timeZone,
            timeZoneName: 'short',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    catch (e) {
        dispatch({ type: REPORT_ERROR, payload: { error: e } });
        return date.toLocaleTimeString(FALLBACK_LOCALE, {
            timeZone: FALLBACK_TIMEZONE,
            timeZoneName: 'short',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
};
export const getLocalizedEventDate = (date, formattedLocaleString, timeZone, dispatch) => {
    try {
        return date.toLocaleDateString(formattedLocaleString, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone,
        });
    }
    catch (e) {
        dispatch({ type: REPORT_ERROR, payload: { error: e } });
        return date.toLocaleDateString(FALLBACK_LOCALE, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: FALLBACK_TIMEZONE,
        });
    }
};
